import script from "./MensajeConfirmacion.vue?vue&type=script&lang=ts&setup=true"
export * from "./MensajeConfirmacion.vue?vue&type=script&lang=ts&setup=true"

import "./MensajeConfirmacion.vue?vue&type=style&index=0&id=0a520257&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a520257"]])

export default __exports__